module.exports = " <div class=\"share-palette clearfix\" _v-7c4b9fd2=\"\"> <div class=\"palette-button share-palette-item\" data-cmd=share data-arg=facebook _v-7c4b9fd2=\"\"> <div class=\"share-icon share-icon-facebook\" _v-7c4b9fd2=\"\"></div> </div> <div class=\"palette-button share-palette-item\" data-cmd=share data-arg=twitter _v-7c4b9fd2=\"\"> <div class=\"share-icon share-icon-twitter\" _v-7c4b9fd2=\"\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-7c4b9fd2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/palettes/Share.vue
// module id = 186
// module chunks = 2